import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960,480.667 C429.807,480.667 0,910.474 0,1440.67 L1920,1440.67 C1920,910.474 1490.19,480.667 960,480.667 Z M1261.79,1334 C1217.86,1209.71 1099.33,1120.67 960,1120.67 C827.452,1120.67 713.726,1201.26 665.147,1316.11 C662.662,1321.98 660.347,1327.95 658.209,1334 L1261.79,1334 Z M1232,886.001 C1276.18,886.001 1312,850.183 1312,806.001 C1312,761.818 1276.18,726.001 1232,726.001 C1187.82,726.001 1152,761.818 1152,806.001 C1152,850.183 1187.82,886.001 1232,886.001 Z M768,806.001 C768,850.183 732.182,886.001 688,886.001 C643.817,886.001 608,850.183 608,806.001 C608,761.818 643.817,726.001 688,726.001 C732.182,726.001 768,761.818 768,806.001 Z M1445.33,1035.334 C1489.52,1035.334 1525.33,999.516 1525.33,955.334 C1525.33,911.151 1489.52,875.334 1445.33,875.334 C1401.15,875.334 1365.33,911.151 1365.33,955.334 C1365.33,999.516 1401.15,1035.334 1445.33,1035.334 Z M1653.33,1179.33 C1653.33,1223.52 1617.52,1259.33 1573.33,1259.33 C1529.15,1259.33 1493.33,1223.52 1493.33,1179.33 C1493.33,1135.15 1529.15,1099.33 1573.33,1099.33 C1617.52,1099.33 1653.33,1135.15 1653.33,1179.33 Z M474.666,1035.334 C518.849,1035.334 554.666,999.516 554.666,955.334 C554.666,911.151 518.849,875.334 474.666,875.334 C430.484,875.334 394.666,911.151 394.666,955.334 C394.666,999.516 430.484,1035.334 474.666,1035.334 Z M426.667,1179.33 C426.667,1223.52 390.849,1259.33 346.667,1259.33 C302.484,1259.33 266.667,1223.52 266.667,1179.33 C266.667,1135.15 302.484,1099.33 346.667,1099.33 C390.849,1099.33 426.667,1135.15 426.667,1179.33 Z M960,827.334 C1004.18,827.334 1040,791.516 1040,747.334 C1040,703.151 1004.18,667.334 960,667.334 C915.817,667.334 880,703.151 880,747.334 C880,791.516 915.817,827.334 960,827.334 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconProtractorSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconProtractorSolid, _Component);

  var _super = _createSuper(IconProtractorSolid);

  function IconProtractorSolid() {
    _classCallCheck(this, IconProtractorSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconProtractorSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconProtractor",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconProtractorSolid.displayName = "IconProtractorSolid";
  return IconProtractorSolid;
}(Component);

IconProtractorSolid.glyphName = 'protractor';
IconProtractorSolid.variant = 'Solid';
IconProtractorSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconProtractorSolid;
export { IconProtractorSolid };